import { useContext } from 'react';
import { AddAlarmDialogContext } from './context';

export function useAddAlarmDialog() {
  const context = useContext(AddAlarmDialogContext);
  if (!context) {
    throw new Error(
      'useAddAlarmDialog must be used within AddAlarmDialogProvider'
    );
  }
  return context;
}
